import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import {
  IFlag,
  IFlagOption,
  IFlagRequest,
  IPersonFlag,
  IPersonFlagRequest,
  IPersonFlagUpdateRequest,
  IPersonFlagDeleteRequest,
  ISystemFlagRequest,
} from '@/models';

import { http } from './http';
import { IGetParams, IPaginatedListResponse } from './types';

export const FlagsApi = {
  // Flag Management
  getFlags: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<IFlag>>> => {
    return http.get(`api/${ApiVersion.V1}/flags`, { params });
  },

  getFlagOptions: (): Promise<AxiosResponse<IFlagOption[]>> => {
    return http.get(`api/${ApiVersion.V1}/flags/options`);
  },

  getFlag: (id: string): Promise<AxiosResponse<IFlag>> => {
    return http.get(`api/${ApiVersion.V1}/flags/${id}`);
  },

  createFlag: (data: IFlagRequest): Promise<AxiosResponse<IFlag>> => {
    return http.post(`api/${ApiVersion.V1}/flags`, data);
  },

  updateFlag: (
    id: string,
    data: IFlagRequest,
  ): Promise<AxiosResponse<IFlag>> => {
    return http.put(`api/${ApiVersion.V1}/flags/${id}`, data);
  },

  deleteFlag: (id: string): Promise<AxiosResponse<null>> => {
    return http.delete(`api/${ApiVersion.V1}/flags/${id}`);
  },

  // Person Flag Management
  getPersonFlags: (
    personId: string,
    params?: IGetParams,
  ): Promise<AxiosResponse<IPersonFlag[]>> => {
    return http.get(
      `api/${ApiVersion.V1}/master-names/persons/${personId}/flags`,
      { params },
    );
  },

  assignPersonFlag: (
    personId: string,
    data: IPersonFlagRequest,
  ): Promise<AxiosResponse<IPersonFlag>> => {
    return http.post(
      `api/${ApiVersion.V1}/master-names/persons/${personId}/flags`,
      data,
    );
  },

  getAvailableFlags: (
    personId: string,
  ): Promise<AxiosResponse<IFlagOption[]>> => {
    return http.get(
      `api/${ApiVersion.V1}/master-names/persons/${personId}/flags/available`,
    );
  },

  assignSystemFlag: (
    personId: string,
    data: ISystemFlagRequest,
  ): Promise<AxiosResponse<IPersonFlag>> => {
    return http.post(
      `api/${ApiVersion.V1}/master-names/persons/${personId}/flags/system`,
      data,
    );
  },

  getPersonFlag: (
    personId: string,
    flagId: string,
  ): Promise<AxiosResponse<IPersonFlag>> => {
    return http.get(
      `api/${ApiVersion.V1}/master-names/persons/${personId}/flags/${flagId}`,
    );
  },

  updatePersonFlag: (
    personId: string,
    flagId: string,
    data: IPersonFlagUpdateRequest,
  ): Promise<AxiosResponse<IPersonFlag>> => {
    return http.put(
      `api/${ApiVersion.V1}/master-names/persons/${personId}/flags/${flagId}`,
      data,
    );
  },

  removePersonFlag: (
    personId: string,
    flagId: string,
    data: IPersonFlagDeleteRequest,
  ): Promise<AxiosResponse<null>> => {
    return http.delete(
      `api/${ApiVersion.V1}/master-names/persons/${personId}/flags/${flagId}`,
      { data },
    );
  },
};
